import React from "react";
import { NoSettings } from "./sectionFormKit";

// Customer: components/sections/Login/Login.js
const Login = () => <NoSettings text="Sign-in form. No settings." />;

export default Login;
